/**
 * Tipos canônicos de adversarial/bubbles/conflict — Fatia C.
 *
 * Fonte da verdade dos enums + tipos para Engine + frontends.
 */
// ─── Session Context (ADR-040) ───────────────────────────────────────────
export const SESSION_CONTEXTS = [
    'private-caucus-a',
    'private-caucus-b',
    'joint',
    'formal',
];
// ─── ConfidentialityBubble (ADR-047) ─────────────────────────────────────
export const BUBBLE_VISIBILITY_MODES = [
    'only-creator',
    'creator-and-specific-roles',
    'creator-and-list',
];
// ─── LegalCapacity (ADR-047) ─────────────────────────────────────────────
export const LEGAL_CAPACITY_STATUSES = ['full', 'limited', 'none', 'age-restricted'];
export const LEGAL_CAPACITY_BASES = [
    'age',
    'cognitive',
    'curatela-judicial',
    'temporal',
    'age-progressive',
];
// ─── Guardianship (ADR-047) ──────────────────────────────────────────────
export const GUARDIANSHIP_TYPES = [
    'legal-guardian',
    'curator',
    'authorized-caregiver',
    'temporary',
    'emergency-contact',
];
export const GUARDIANSHIP_BASES = [
    'court-order',
    'parental',
    'attorney-power',
    'declared-by-titular',
    'emergency-protocol',
];
export const GUARDIANSHIP_STATUSES = ['active', 'suspended', 'revoked', 'expired'];
// ─── ConflictAlert (ADR-050) ─────────────────────────────────────────────
export const CONFLICT_CATEGORIES = [
    'category-a-societario',
    'category-b-papel-duplo',
    'category-c-informacao-privilegiada',
    'category-d-exclusividade',
    'category-e-capacidade-limitada',
];
export const CONFLICT_SEVERITIES = ['low', 'medium', 'high', 'critical'];
export const CONFLICT_ALERT_STATUSES = [
    'open',
    'acknowledged',
    'mitigated',
    'false-positive',
    'accepted',
];
/**
 * Severidade default por categoria (ADR-050). v1 hardcoded; configurável
 * por tenant pós-v1.
 */
export const CONFLICT_DEFAULT_SEVERITY = {
    'category-a-societario': 'medium',
    'category-b-papel-duplo': 'high',
    'category-c-informacao-privilegiada': 'high',
    'category-d-exclusividade': 'medium',
    'category-e-capacidade-limitada': 'low',
};
//# sourceMappingURL=index.js.map